module.exports = __webpack_public_path__ + "static/media/puzzle-piece.624032c9.svg";